if (process.env.NODE_ENV === 'production') {
    global.host = 'https://api.brflyfta.se/api/'
    global.hostFiles = 'https://api.brflyfta.se/uploads/'
} else {
    global.host = 'http://localhost/api/'
    global.hostFiles = 'http://localhost/uploaded_files/'
}

global.hostname = ' | Brf Lyfta'
